/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import CONST_QRCODES from 'constants/qrcodes';

// Styles
import useStyles from './qrcodeFilter.styles';

const QRCodeFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const filteredQRCodes = useSelector(
    (state: ApplicationState) => state.reports.selectedQRCodes,
  );

  const handleQRCode = (qrcode: any) => {
    const updated = [...filteredQRCodes];
    const index = filteredQRCodes.findIndex((e) => e.key === qrcode.KEY);

    if (index === -1) updated.push({ key: qrcode.KEY, value: qrcode.VALUE });
    else updated.splice(index, 1);

    dispatch(
      ReportActions.setSelectedQRCodes({
        selectedQRCodes: updated,
      }),
    );
  };

  return (
    <List dense>
      {CONST_QRCODES.ENTRY.map((item) => (
        <ListItem key={item.KEY} button>
          <ListItemText
            primary={item.VALUE}
            onClick={() => handleQRCode(item)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              color='primary'
              onChange={() => handleQRCode(item)}
              checked={!!filteredQRCodes.find((e) => e.key === item.KEY)}
              inputProps={{ 'aria-labelledby': item.VALUE}}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { QRCodeFilter };
export default QRCodeFilter;
